import { Location } from "../../../types";
import MultiRestaurantSelection from "./MultiRestaurantSelection";
import StandardSelection from "./StandardSelection";

export interface TimelineProps {
  location: Location;
}

function Timeline({ location: { franchiseOpportunity } }: TimelineProps) {
  const { operatorSelectionTimeline } = franchiseOpportunity;

  if (operatorSelectionTimeline.includes("13")) {
    return (
      <MultiRestaurantSelection franchiseOpportunity={franchiseOpportunity} />
    );
  }
  return <StandardSelection franchiseOpportunity={franchiseOpportunity} />;
}

export default Timeline;
